import { storeToRefs } from 'pinia';
import { useAgentsStore, useAgentsSetters } from './use-agents-store';
import { useAgentStatusActions } from './use-agent-status-actions';
import { useAgentsActions } from './use-agents-actions';

export { AgentStatusResponse } from './types';
export const useAgents = () => {
  return {
    ...storeToRefs(useAgentsStore()),
    ...useAgentsSetters(),
    ...useAgentStatusActions(),
    ...useAgentsActions(),
  };
};
